export const STOCK_PHOTO_TYPE = 'stock-photos'
export const STOCK_VIDEO_TYPE = 'stock-videos'
export const STOCK_GIF_TYPE = 'stock-gifs'

export const STOCK_ALL_FILTER = 'stock-all'
